import logger from './logger'
import $ from 'jquery'
import sasad from './ads/sas/sas'
import outbrain from './ads/outbrain/outbrain'

const ads = {}

/**
 * Custom sas events logic for this project
 */
const sasEvents = {
    beforeRender: (data) => {
        var element = $('#sas_' + data.formatId);
        
        if (typeof MutationObserver !== 'undefined') {
            var observer = new MutationObserver(function () {
                $(window).trigger('cs:bannerLoad');
            });
            observer.observe(element.get(0), {
                attributes: false,
                childList: true,
                characterData: false
            });
        } else {
            $(element).on('DOMSubtreeModified', function () {
                $(window).trigger('cs:bannerLoad');
                $(element).off('DOMSubtreeModified');
            });
        }
        
        $('body').addClass('top-banner-f3');
    },
    onLoad: (data) => {
        setTimeout(function () {
            $(window).trigger('cs:bannerLoad');
        }, 400);
    },
    onError: (data) => {
        setTimeout(function () {
            $(window).trigger('cs:bannerLoad');
        }, 400);

        var element = $('#sas_' + data.formatId);
        
        if (element.length !== 0) {
            element.remove();
        }
    },
}

/**
 * Method to inject ads scripts into the dom
 */
const handeDomInjections = () => {
    sasad.domInjection(
        'https://ced.sascdn.com/tag/1778/smart.js',
        '//tagmanager.smartadserver.com/1778/96478/smart.prebid.js'
    )
    outbrain.domInjection()

    // More injection should be here
}

/**
 * Method to handle (initialize/push) sas banners
 */
const handleSas = () => {
    if (!window.sas) {
        logger.log("No Sas instance available")
        return
    }

    $('cs-ads').each((_idx, el) => {
        const {
            siteId,
            pageId,
            formatId,
            target,
            events
        } = $(el).data()

        const smartEvents = (!events || events === 'enabled') ? sasEvents : {}
        const props = {
            siteId,
            pageId,
            formatId,
            target
        }
        
        sasad.push(props, smartEvents)
    })
}

ads.init = () => {
    handeDomInjections()
    handleSas() 
}

export default ads